import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaChartLine,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaVideo,
} from "react-icons/fa";

import slider1 from "../assets/slider.jpg";
import slider2 from "../assets/slideer1.jpg";
import slider3 from "../assets/slider3.jpg";
import slider4 from "../assets/slider4.png";
import slider5 from "../assets/slider5.png";
import profileImage from "../assets/Profile.jpg";
import reportFile from "../assets/report.pdf"; // Add your report file


const PoliticalLeader = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const videos = [
    "https://www.youtube.com/watch?v=K-vhjMTzIbo",
    "https://www.youtube.com/watch?v=2XHvs3Hoc5s",
    "https://www.youtube.com/watch?v=ftR1ue6R764",
    "https://www.youtube.com/watch?v=Yq51cNTEWkU",
    "https://www.youtube.com/watch?v=Ok9NRutReC0",
    "https://www.youtube.com/watch?v=l37gzcDbXfI"
  ];

  const getYouTubeID = (url) => {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // Handle download
  const handlePdfview = () => {

    if (reportFile) {
      window.open(reportFile, '_blank'); // Opens PDF in new tab instantly
    } else {
      console.error('PDF file not found.');
    }

  };

  // Handle view video
  const handleViewVideo = () => {
    setShowVideoModal(true);
  };

  // Handle close video modal
  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
  };

  // fade animation on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("fade-in");
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".fade-on-scroll").forEach((el) => observer.observe(el));
  }, []);

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", lineHeight: 1.6 }}>

      <section className="position-relative overflow-hidden" style={{ maxHeight: '600px ' }}>
        <div className="d-flex w-100 animate-slider">
          {[slider1, slider2, slider3].map((img, idx) => (
            <div key={idx} className="flex-shrink-0 w-100 position-relative">
              {/* Bootstrap aspect ratio container */}
              <div className="ratio" style={{ aspectRatio: "16 / 9" }}>
                <img
                  src={img}
                  alt={`Slide ${idx + 1}`}

                  style={{ backgroundColor: "#000", maxHeight: '600px' }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* Profile Section */}
      <Container className="my-2 fade-on-scroll" style={{ fontFamily: "'Poppins', sans-serif" }}>
        <div className="d-flex justify-content-center align-items-center mb-3 p-3 bg-light rounded-3 shadow-sm flex-wrap gap-3 text-center">
          <Button
            variant="danger"
            className="fw-bolder mb-0 text-white"
            style={{ color: "#C21807" }}  // टेक्स्ट लाल रंग में
            onClick={handlePdfview}
          >
            घोसी विधानसभा का विकास रिपोर्ट 2020-25
          </Button>
          <Button
            className="btn zoom-btn"
            style={{
              backgroundColor: "#28a745",  // हरा रंग
              color: "#fff",
              fontWeight: "bold",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              border: "none"
            }}
            download
            onClick={handlePdfview}
          >
            डाउनलोड करें
          </Button>
        </div>


        <Card className="border-0 rounded-4 overflow-hidden mx-auto profile-card bg-light shadow-sm">
          <Row className="g-0 align-items-center">

            {/* Left Section */}
            <Col md={4} className="text-center border-end p-4 profilesection" >
              <img
                src={profileImage}
                alt="Rambali singh Yadav"
                className="img-fluid rounded-4 mb-4 profile-img"
                style={{ maxWidth: "300px", marginBottom: "1.5rem", height: '500px' }}
              />
              <h4
                className="fw-bold mb-1"
                style={{ color: "#C21807", fontFamily: "'Merriweather', serif" }}
              >
                कॉ. रामबली सिंह यादव
              </h4>
              <p className="text-muted mb-2" style={{ fontSize: "0.95rem" }}>
                विधायक,घोसी विधानसभा, बिहार
              </p>
              <div className="mb-3">
                {/* <Badge bg="success" className="me-2 fs-6">सक्रिय नेता</Badge> */}
                <Badge bg="danger" className="fs-6">CPI (ML)</Badge>
              </div>
              <blockquote
                className="fst-italic text-secondary small"
                style={{ fontFamily: "'Merriweather', serif" }}
              >
                “सच्चा नेतृत्व सेवा और साथ देने में है।”
              </blockquote>
            </Col>

            {/* Right Section */}
            <Col md={8} className="p-4">
              <Card.Body>
                <div
                  className="text-secondary"
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    textAlign: "justify",
                    whiteSpace: "pre-line",
                  }}
                >
                  <strong style={{ color: "red" }}>कॉमरेड रामबली सिंह यादव — घोसी विधानसभा</strong>{"\n\n"}
                  🔸 <strong style={{ color: "red" }}>जनसेवा और विकास का निरंतर सफ़र</strong>{"\n"}

                  कॉमरेड रामबली सिंह यादव, घोसी विधानसभा के वह जनप्रिय नेता हैं जिन्होंने राजनीति को सेवा का माध्यम बनाया।{"\n"}
                  विधायक के रूप में उनका कार्यकाल जनता के विश्वास, पारदर्शिता और विकास के ठोस कार्यों से भरा रहा है।{"\n\n"}

                  <strong style={{ color: "red" }}>🏗 विकास योजनाओं का व्यापक क्रियान्वयन</strong>{"\n"}
                  विधायक निधि से 340 गांवों में 355 योजनाओं का निर्माण करवाया गया।{"\n"}
                  अधिकांश योजनाएँ पूरी हो चुकी हैं, शेष कार्य प्रगति पर है।{"\n"}
                  हर गरीब टोले में सामुदायिक भवन और छायादार चबूतरे का निर्माण किया गया।{"\n"}
                  योजनाओं की प्राथमिकता – गरीब, दलित, अतिपिछड़े, पिछड़े और किसान।{"\n"}
                  कई ऐसे गांवों तक विकास की रौशनी पहुंचाई, जहाँ पहले कोई जनप्रतिनिधि तक नहीं पहुँचा था।{"\n\n"}

                  <strong style={{ color: "red" }}>📚 शिक्षा और युवाओं के सशक्तिकरण की दिशा में कदम</strong>{"\n"}
                  विद्यालयों में 2120 मेज और 510 अलमारियां प्रदान की गईं।{"\n"}
                  कई शिक्षण संस्थानों में जिम और खेल सुविधाएँ स्थापित की गईं।{"\n"}
                  शिक्षा की गुणवत्ता सुधार और बेहतर इंफ्रास्ट्रक्चर सुनिश्चित करने में विधायक निधि का सदुपयोग।{"\n\n"}

                  <strong style={{ color: "red" }}>🤝 जनता से सीधा और जीवंत संपर्क</strong>{"\n"}
                  विधायक कॉ. रामबली सिंह यादव प्रतिदिन अपने आवास पर जनता से मुलाकात करते हैं।{"\n"}
                  जनता की शिकायतों और समस्याओं का तत्काल निस्तारण सुनिश्चित किया जाता है।{"\n"}
                  बिजली, चापाकल, ट्रांसफार्मर जैसे मुद्दों पर तत्काल कार्यवाही।{"\n"}
                  मुख्यमंत्री स्वास्थ्य सेवा योजना के तहत सैकड़ों मरीजों को लाखों की राहत दिलवाई गई।{"\n"}
                  दुर्घटनाओं के पीड़ित परिवारों को मुआवजा दिलवाने के लिए सरकार पर दबाव बनाने से भी पीछे नहीं हटे।{"\n\n"}

                  <strong style={{ color: "red" }}>✊ संघर्षों में सदैव अग्रणी भूमिका</strong>{"\n"}
                  अन्याय, सामंती जुल्म या पुलिसिया दमन के खिलाफ हर संघर्ष में सबसे आगे रहे।{"\n"}
                  भूमिहीन गरीबों, शिक्षकों, स्कीम वर्करों, आशा-आंगनबाड़ी कर्मियों के अधिकारों की लड़ाई लड़ी।{"\n"}
                  प्रदेश के भीतर ही नहीं बल्कि दिल्ली के किसान आंदोलन में भी सक्रिय रूप से शामिल रहे।{"\n"}
                  हर गरीब और वंचित वर्ग की आवाज़ को सशक्त मंच दिया।{"\n\n"}

                  <strong style={{ color: "red" }}>🏛 विधानसभा में 100% उपस्थिति</strong>{"\n"}
                  विधानसभा सत्रों में पूर्ण उपस्थिति (100%) बनाए रखी।{"\n"}
                  शून्यकाल के प्रश्नों, निवेदनों और याचिकाओं के माध्यम से जनता की आवाज़ को सदन तक पहुँचाया।{"\n"}
                  सरकार को जनता की समस्याओं के समाधान के लिए जवाबदेह बनाया।{"\n\n"}

                  <strong style={{ color: "red" }}>🌾 जनता का आह्वान</strong>{"\n"}
                  घोसी विधानसभा के निरंतर विकास, शिक्षा, रोजगार और न्याय की इस यात्रा को आगे बढ़ाने के लिए —{"\n\n"}

                  🗓 मतदान तिथि: 11 नवंबर{"\n"}
                  🚩 प्रत्याशी: कॉ. रामबली सिंह यादव{"\n"}
                  🟥 दल: भाकपा (माले) — महागठबंधन समर्थित{"\n"}
                  🔘 क्रम संख्या: 2{"\n"}
                  🎈 चुनाव चिन्ह: झंडे पर तीन तारा{"\n\n"}

                  📢 झंडे पर तीन तारा – जनता की ताक़त, बदलाव की गारंटी!{"\n"}
                  👉 11 नवंबर को ईवीएम पर क्रम संख्या 2 दबाएँ और जनसेवा के इस सफ़र को आगे बढ़ाएँ।
                </div>
              </Card.Body>


            </Col>
          </Row>
        </Card>

      </Container>


      <Container
        className="my-5 fade-on-scroll py-5 animated-section"
        style={{
          borderRadius: "20px",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <h2
          className="fw-bold text-center text-danger mb-3"
          style={{
            fontSize: "2.5rem",
            position: "relative",
            display: "inline-block",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          घोसी विधानसभा का <span style={{ color: "#C21807" }}>विकास रिपोर्ट</span> 2020–25

          <span
            style={{
              display: "block",
              width: "80px",
              height: "5px",
              backgroundColor: "#C21807",
              borderRadius: "2px",
              margin: "10px auto 0",
            }}
          ></span>
        </h2>

        {/* <p
    className="text-center text-secondary mb-5"
    style={{
      maxWidth: "800px",
      margin: "0 auto",
      fontSize: "1.2rem",
      lineHeight: "1.8",
    }}
  >
    Get complete insights into the development work, public welfare initiatives, 
    and community engagement led by <strong>Kr. Arun Singh</strong> in the Karakat Assembly constituency for the years 2020–25. Access detailed reports and visual summaries below.
  </p> */}

        <Row className="g-4 justify-content-center mt-4">
          {/* Report Card */}
          <Col md={5}>
            <Card
              className="border-0 h-100 text-center p-4 animated-card"
              style={{
                backgroundColor: "white",
                border: "2px solid #f8d7da",
                borderRadius: "15px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Card.Body>
                <FaChartLine
                  size={50}
                  className="text-danger mb-3 animated-icon"
                />
                <Card.Title
                  className="fw-bold mb-3"
                  style={{ fontSize: "1.6rem" }}
                >
                  घोसी विधानसभा का विकास रिपोर्ट कार्ड 2020–25
                </Card.Title>
                <Card.Text
                  className="text-secondary mb-4"
                  style={{ fontSize: "1.05rem", lineHeight: "1.7" }}
                >
                  विकास कार्यों, जनकल्याण पहल और प्रदर्शन रिकॉर्ड की पूरी जानकारी प्राप्त करें।
                </Card.Text>
                <Button
                  variant="danger"
                  className="px-5 py-2 fw-semibold custom-button"
                  onClick={handlePdfview}
                >
                  Download
                </Button>
                <p className="info-note mt-3" style={{ fontSize: "0.95rem" }}>
                  📄 यहाँ क्लिक करें और घोसी विधानसभा का विकास रिपोर्ट 2020–25 डाउनलोड करें।
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Report Video */}
          <Col md={5}>
            <Card
              className="border-0 h-100 text-center p-4 animated-card"
              style={{
                backgroundColor: "white",
                border: "2px solid #f8d7da",
                borderRadius: "15px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Card.Body>
                <FaVideo
                  size={50}
                  className="text-danger mb-3 animated-icon"
                />
                <Card.Title
                  className="fw-bold mb-3"
                  style={{ fontSize: "1.6rem" }}
                >
                  घोसी विधानसभा का विकास रिपोर्ट वीडियो 2020–25
                </Card.Title>
                <Card.Text
                  className="text-secondary mb-4"
                  style={{ fontSize: "1.05rem", lineHeight: "1.7" }}
                >
                  आकर्षक दृश्य प्रस्तुतियों के माध्यम से कार्यक्रम हाइलाइट्स, सामुदायिक संपर्क और सार्वजनिक बैठकों का अन्वेषण करें।
                </Card.Text>
                <Button
                  variant="danger"
                  className="px-5 py-2 fw-semibold custom-button"
                  onClick={handleViewVideo}
                >
                  View
                </Button>
                <p className="info-note mt-3" style={{ fontSize: "0.95rem" }}>
                  🎥 यहाँ क्लिक करें और घोसी विधानसभा का विकास रिपोर्ट 2020–25 देखें।
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>


      {/* Video Modal */}
      <Modal
        show={showVideoModal}
        onHide={handleCloseVideoModal}
        fullscreen
        centered
        className="video-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-5">Report Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9 w-100 h-100">
            <iframe
              src="https://www.youtube.com/embed/t7O4ctmTyk8"
              title="Report Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ width: "100%", height: "100%" }}
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>


      {/* Social Media Section */}
      <Container className="my-5 fade-on-scroll">
        <h2
          className="fw-bold text-center text-danger mb-4"
          style={{ fontSize: "2rem" }}
        >
          Social Media
        </h2>
        <Row className="g-4 justify-content-center">
          {[
            {
              icon: <FaFacebook size={32} color="#1877F2" />,
              title: "Follow on Facebook",
              src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F698862832770349%2F&show_text=false&width=380&t=0",
              link: "https://www.facebook.com/RAMBALISIGH8",
            },
            {
              icon: <FaInstagram size={32} color="#E4405F" />,
              title: "Follow on Instagram",
              src: "https://www.instagram.com/rambalicpiml/embed",
              link: "https://www.instagram.com/rambalicpiml/"
            },
            {
              icon: <FaYoutube size={32} color="#FF0000" />,
              title: "Follow on YouTube",
              src: "https://www.youtube.com/embed/K-vhjMTzIbo",
              link: "https://www.youtube.com/@RamBaliCPIML" // your actual channel link
            }
          ].map((item, idx) => (
            <Col md={4} key={idx}>
              {/* ✅ Make the whole card clickable */}
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card className="border-0 shadow-sm text-center p-3 hover-card">
                  <Card.Body>
                    <h4
                      className="fw-bold mb-3 d-flex justify-content-center align-items-center gap-2"
                      style={{ fontSize: "1.25rem" }}
                    >
                      {item.icon} {item.title}
                    </h4>

                    <iframe
                      width="100%"
                      height="400"
                      src={item.src}
                      title={item.title}
                      frameBorder="0"
                      className="rounded"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>



      {/* More Information Section */}

      <Container className="my-5 py-5 fade-on-scroll bg-gradient-light rounded-4">
        {/* Section Header */}
        <div className="text-center mb-5">
          <div className="bg-danger bg-opacity-10 rounded-3 p-4 d-inline-block mb-3">
            <FaYoutube size={48} className="text-danger mb-3" />
            <h2 className="fw-bold display-5 text-dark mb-2">
              View Some More Videos
            </h2>
          </div>
          <p className="lead text-muted mx-auto" style={{ maxWidth: "600px" }}>
            रामबली सिंह यादव के नवीनतम भाषणों और जन-संपर्क गतिविधियों का अन्वेषण करें
          </p>
        </div>

        <Row className="g-4 justify-content-center">
          {videos.map((videoUrl, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="border-0 shadow rounded-4 overflow-hidden h-100 hover-shadow">
                <div className="position-relative">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={`https://www.youtube.com/embed/${getYouTubeID(videoUrl)}`}
                      title={`Rambali Singh Yadav Speech ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="rounded-top-4"
                      style={{ border: "none" }}
                    ></iframe>
                  </div>
                </div>


              </Card>
            </Col>
          ))}
        </Row>

      </Container>


      {/* Footer */}
      <footer className="bg-danger text-white text-center py-4 mt-5 footer">
        <Container>
          <p className="mb-2 fw-bold">© {new Date().getFullYear()} Rambali Singh Yadav | CPI (ML)</p>
          <div className="mt-2 d-flex justify-content-center gap-3">
            <a href="https://www.facebook.com/RAMBALISIGH8" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaFacebook size={24} />
            </a>
            <a href="https://www.instagram.com/rambalicpiml/" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaInstagram size={24} />
            </a>
            <a href="https://www.youtube.com/@RamBaliCPIML" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaYoutube size={24} />
            </a>
          </div>
        </Container>
      </footer>

      {/* Animations & Styles */}
      <style>{`
        @keyframes slide {
          0%, 20% { transform: translateX(0); }
          25%, 45% { transform: translateX(-100%); }
          50%, 70% { transform: translateX(-200%); }
          75%, 95% { transform: translateX(-300%); }
          100% { transform: translateX(-400%); }
        }
        .animate-slider { animation: slide 20s infinite linear; }
        .hero-text h1 { animation: fadeInUp 1.5s ease forwards; opacity:0; }
        .hero-text p { animation: fadeInUp 2s ease forwards; opacity:0; }
        @keyframes fadeInUp { 0% { transform: translateY(20px); opacity:0;} 100% { transform: translateY(0); opacity:1;} }
        .profile-card:hover { transform: translateY(-5px); transition: all 0.3s; }
        .profile-img:hover { transform: scale(1.05); transition: all 0.3s; }
        .achievement-card { transition: all 0.3s; }
        .achievement-card:hover { transform: scale(1.05); box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
        .hover-card { transition: all 0.3s; }
        .hover-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
        .fade-on-scroll { opacity:0; transform: translateY(30px); transition: all 0.8s ease; }
        .fade-on-scroll.fade-in { opacity:1; transform: translateY(0); }
        .footer a:hover { color: #ffd6d6; transition: 0.3s; }
        
        /* Video Modal Styles */
        .video-modal .modal-content {
          max-height: 70vh;
        }
        .video-modal .modal-body {
          padding: 0;
        }
        .video-modal .ratio-16x9 {
          height: 400px;
        }
        @keyframes gradientShift {
  0% { background: linear-gradient(135deg, #fff5f5, #ffeaea); }
  50% { background: linear-gradient(135deg, #ffeaea, #fff0f0); }
  100% { background: linear-gradient(135deg, #fff5f5, #ffeaea); }
}

@keyframes pulseIcon {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.9; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes borderGlow {
  0% { border-color: #f8d7da; }
  50% { border-color: #C21807; }
  100% { border-color: #f8d7da; }
}

.animated-section {
  animation: gradientShift 6s ease-in-out infinite;
}

.animated-card {
  animation: borderGlow 4s ease-in-out infinite;
}

.animated-icon {
  animation: pulseIcon 3s ease-in-out infinite;
}

.info-note {
  font-size: 0.9rem;
  color: #C21807;
  font-style: italic;
  margin-top: 8px;
}
@keyframes zoomInOut {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.zoom-btn {
  animation: zoomInOut 1.5s infinite;
}
@media (min-width: 992px) {
  .profilesection {
    margin-bottom: 45%;
  }
}
.custom-button {
  border-radius: 30px;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.custom-button:hover {
  background-color: green !important; 
  border-color: green !important;     
}
      `}</style>
    </div>
  );
};

export default PoliticalLeader;